import { axiosPublic, axiosPublicNew, axiosPublicBooking, axiosPublicBelieve } from "../config/axios";
import { getSeason } from "../utils";
const handleError = (err) => {
    console.log(err);
}

const init = async (values) => {
    const seasons = await getSeason(values[1].data.data);
    return {
        config: values[0].data.config,
        seasons: seasons
    };
}

export const getIni = async () => {
    try {
        const _data = await Promise.all([
            axiosPublic.get("appConfig"),
            axiosPublicNew.get("enquiries/seasons"),
        ]).then((values) => {
            return init(values);
        }).then((data) => {
            return data;
        }).catch((err) => {
            handleError(err);
        });
        return _data
    } catch (error) {
        handleError(error)
    }
}

export const getAppConfig = async () => {
    try {
        let request = await axiosPublic.get("appConfig");
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const getSeassons = async () => {
    try {
        let request = await axiosPublicNew.get("enquiries/seasons");
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const getBookings = async (_guest, _checkin, _checkout) => {
    try {//"YYYY-MM-DD"
        let request = await axiosPublicBooking.get(`bookings?guestCount=${_guest}&checkIn=${_checkin}&checkOut=${_checkout}`);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const getRooms = async () => {
    try {
        let request = await axiosPublicBooking.get(`rooms`);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const getAvailability = async (_guests, _checkin, _checkout) => {
    try {//"YYYYMMDD"
        let request = await axiosPublicBelieve.get(`reservas/disponibilidad/r/${_checkin}/${_checkout}/${_guests}`);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const getPacks = async () => {
    try {
        let request = await axiosPublic.get(`packs`);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const getCustomizerSteps = async () => {
    try {
        let request = await axiosPublic.get(`customizerSteps`);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const getEnquirie = async (view) => {
    try {
        let request = await axiosPublic.get(`enquiry?hash=${view}`);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const getPack = async (pack_slug) => {
    try {
        let request = await axiosPublic.get(`pack?slug=${pack_slug}`);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const checkPromoCode = async (code, email, nights, season, id) => {
    try {
        let request = await axiosPublic.get(`checkPromoCode?code=${code}&email=${email}&nights=${nights}&season_id=${season}&room_id=${id}`);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

//TAMBIEN PARA CONTACT US
export const sendEnquirie = async (_data) => {
    try {
        console.log(_data)
        let request = await axiosPublicNew.post(`enquiries`, _data);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const sendBooking = async (_data) => {
    try {
        let request = await axiosPublicBooking.post(`bookings`, _data);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}

export const sendLogin = async (_data) => {
    try {
        let request = await axiosPublicBooking.post(`login`, _data);
        return request.data;
    } catch (error) {
        handleError(error)
    }
}


export const getLafisePublic = async () => {
    try {
        let request = await axiosPublicBelieve.get("lafise_gral/publickey")
        return request
    } catch (error) {
        handleError(error)
    }
};

export const processPayment = async (_data) => {
    try {
        let request = await axiosPublicBelieve.post("public/pay", _data)
        return request
    } catch (error) {
        handleError(error)
    }
};

export const createPaymentIntent = async (_data) => {
    try {
        let request = await axiosPublicBelieve.post("public/payment_intent", _data)
        return request
    } catch (error) {
        handleError(error)
    }
};


